module.exports = __webpack_public_path__ + "img/menu8.b11befbc.png";